import { useMemo } from "react";
import { Container, Heading3, Tabs } from "shared/components";
import { TabsProvider } from "shared/components/Tabs/Tabs.Provider";

import styles from "./Content084.module.scss";
import { Items } from "./Items";

export const Content084 = ({ payload }) => {
  const title = payload?.title ?? "";
  const items = useMemo(() => {
    return payload?.sphereList ?? [];
  }, [payload?.sphereList]);

  const extractedTabs = useMemo(() => {
    return [...new Set(items.map((item) => item.title))];
  }, [items]);

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.block}>
          <Heading3 className={styles.title}>{title}</Heading3>
          <TabsProvider items={extractedTabs} tabsEnabled={true}>
            <Tabs appearance="justify" className={styles.tabs} />
            <Items items={items} />
          </TabsProvider>
        </div>
      </Container>
    </div>
  );
};

export default Content084;
